import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import { useLocation, useNavigate } from "react-router";
import { ReactComponent as UserSvg } from "../../../assets/images/description/User.svg";
import { ReactComponent as EmailSvg } from "../../../assets/images/description/Message.svg";
import { Descriptions } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { listUserTenantFun } from "../../../redux/reducer/TenantSlice";
import useSelection from "antd/es/table/hooks/useSelection";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import CommonFilter from "../../../components/common/filter";
import { Space } from "antd";
import { useDebounce } from "../../../customHooks";

// const cleanObject = (obj) => {
//   return Object.fromEntries(
//     Object.entries(obj).filter(([_, value]) => value !== null || value !== undefined)
//   );
// };

const cleanObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
    )
  );
};

const UserListView = () => {
  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  // Convert URLSearchParams to usable object
  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const position = searchParams.get("position");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };

    if (tableParams.status !== undefined) params.status = tableParams.status;
    if (tableParams.position !== undefined)
      params.position = tableParams.position;

    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  // set page refersh end

  const { listUserTenant, listUserTenantLoading, listUserTenantCount } =
    useSelector((prev) => prev?.tenant);

  const [tenantData, setTenantData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("tenantData");
    if (storedData) {
      setTenantData(JSON.parse(storedData));
    }
  }, []);

  // Update when location.state.tenantData is available
  useEffect(() => {
    const newTenant = location?.state?.tenantData;

    if (newTenant && newTenant.id !== tenantData?.id) {
      setTenantData(newTenant);
      localStorage.setItem("tenantData", JSON.stringify(newTenant)); // Save to localStorage
    }
  }, [location?.state]);

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  useEffect(() => {
    const params = cleanObject(tableParams);
    if (tenantData) {
      dispatch(listUserTenantFun({ tenant_id: tenantData?.id, ...params }));
    }
  }, [
    dispatch,
    tenantData,
    tableParams.page,
    tableParams.size,

    debouncedSearchValue,
    tableParams.status,
    tableParams.position,
    tableParams.from_date,
    tableParams.to_date,
    tableParams.act_from_date,
    tableParams.act_to_date,
  ]);

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const user_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> User’s Name
        </>
      ),
      children: "user",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: "user",
    },
  ];

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) =>
        (tableParams.page - 1) * tableParams.size + index + 1,
      width: "100px",
    },
    {
      title: "Name",
      dataIndex: "name_en",
      key: "category_name",
      type: "search",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "about_author",
      type: "search",
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "created_at",
      type: "date",
      render: (created_at) =>
        created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Activation Date",
      dataIndex: "activation_date",
      key: "act_created_at",
      type: "act_date",
      width: "140px",
      render: (created_at) =>
        created_at ? dayjs(created_at).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Total Listening Time",
      dataIndex: "total_listen_duration",
      key: "total_listen_duration",
      // type: "search",
      width: "180px",
      render: (durationInSeconds) => {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = durationInSeconds % 60;
      
        let result = '';
        if (hours > 0) result += `${hours}h `;
        if (minutes > 0 || hours > 0) result += `${minutes}m `;
        result += `${seconds}s`;
      
        return result.trim();
      }
    },
    {
      title: "Podcast Play",
      dataIndex: "total_listened_count",
      key: "date_added",
      // type: "date",
      width: "120px",
    },
    {
      title: "Podcast Completed",
      dataIndex: "complete_listened_count",
      key: "date_added",
      // type: "date",
      width: "180px",
    },
  ];

  const actionItems = () => [
    {
      key: "view",
      label: (
        <>
          <ViewSvg style={{ marginRight: 8 }} />
          View Details
        </>
      ),
      onClick: (record) => navigate("user/view", { state: { record } }),
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      author_name: "Acme Corp",
      about_author: "Lorem ipsum lorem ipsum",
      podcast_added: 50,

      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      author_name: "Tech Solutions",
      about_author: "Lorem ipsum lorem ipsum",
      podcast_added: 120,

      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      author_name: "Innovate Inc.",
      about_author: "Lorem ipsum lorem ipsum",
      podcast_added: 80,
      status: "Active",
      date_added: "2024-03-01",
    },
  ];

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: listUserTenantCount || 1,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
          from_date: undefined,
          to_date: undefined,
          act_from_date: undefined,
          act_to_date: undefined,
        };
      }
      if (key === "created_at" && (!value || !value.from_date)) {
        return {
          size: prev.size,
          page: prev.page,
        };
      }
      if (key === "act_created_at" && (!value || !value.act_from_date)) {
        return {
          size: prev.size,
          page: prev.page,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      if (typeof value === "object" && value?.from_date) {
        return {
          ...prev,
          from_date: value?.from_date,
          to_date: value?.to_date,
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      if (typeof value === "object" && value?.act_from_date) {
        return {
          ...prev,
          act_from_date: value?.act_from_date,
          act_to_date: value?.act_to_date,
          from_date: "",
          to_date: "",
          search_value: "",
          search_key: "",
          status: undefined,
          position: undefined,
        };
      }
      return {
        ...prev,
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };

  return (
    <div>
      <div>
        <div className="addBx">
          <div className="filterBx">
            <Space>
              <CommonFilter
                columns={columns}
                onFilterChange={handleFilterChange}
                searchValue={tableParams.search_value}
              />
            </Space>
          </div>
        </div>
      </div>
      <ReusableTable
        columns={columns}
        dataSource={listUserTenant}
        loading={false}
        paginationConfig={paginationConfig}
        actionItems={(record) => actionItems(record)}
      />
    </div>
  );
};

export default UserListView;
